<template>
  <div class="parallel-bind">
    <el-card class="box-card" shadow="never">
      <el-page-header @back="goBack" content="设备绑定">
      </el-page-header>
      <el-form class="mt20" ref="form" :inline="true" :model="form" label-width="120px">
        <el-form-item label="项目名称" style="width:30%">
          <el-input v-model="form.projectName" placeholder="请输入项目名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="使用方名称" style="width:30%">
          <el-input v-model="form.owner" placeholder="请选择使用方名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="使用方地址" style="width:30%">
          <el-input v-model="form.locationStr" placeholder="请选择使用方地址" disabled></el-input>
        </el-form-item>
        <el-form-item label="用电类别" style="width:30%">
          <el-select v-model="form.electricityType" placeholder="请选择用电类别" disabled>
            <el-option v-for="(item,index) in useElecList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电压等级" style="width:30%">
          <el-select v-model="form.volLevel" placeholder="请选择并网点电压等级" disabled>
            <el-option v-for="(item,index) in volLevelOptions" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投资方名称" style="width:30%">
          <el-input v-model="form.investor" placeholder="请选择投资方名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="并网点名称" style="width:30%">
          <el-input v-model="form.gridName" placeholder="请选择并网点名称" disabled></el-input>
        </el-form-item>
        <el-form-item label="电表倍率" style="width:30%">
          <el-input v-model="form.rate" placeholder="请选择电表倍率"></el-input>
        </el-form-item>

        <el-form-item label="绑点设备" style="width:30%">
          <SelectTree v-model="form.devicePoint" filterable :props="treeProps" nodeKey="equipId" :data="deviceList">
          </SelectTree>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border height="400" style="width: 100%;margin-top:10px;">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="dataPointTlName" label="数据项名称"></el-table-column>
        <el-table-column prop="equipCode" label="绑定设备"></el-table-column>
        <el-table-column prop="fields" label="数据点名及数据项名称">
          <template slot-scope="scope">
            <span class="device-points" @click="setDevicePoints(scope.row)">
              {{scope.row.fields}}...{{scope.row.fieldsName}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="tools">
        <el-button type="primary" @click="onSaveBindBaseInfo">保存</el-button>
        <el-button type="primary" @click="takeEffectProjectGridEquipBind">配置生效</el-button>
        <el-button type="primary" @click="cancel">取消</el-button>
      </div>
    </el-card>
    <!-- 数据点配置 -->
    <Dialog ref="dlgAdd" :title="dlgTitle" class="parallel-dlg" :closeOnClickModal="false">
      <div class="search-div">
        <el-input placeholder="请输入内容" v-model="keywords" @input="search">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="config-div">
        <div class="tree-wrap">
          <el-tree class="filter-tree" :data="treeDataConfig" highlight-current node-key="id" :props="defaultProps"
            @node-click="handleNodeClick" default-expand-all ref="tree">
          </el-tree>
        </div>
        <div class="points-wrap">
          <el-table :data="filteredData" style="width: 100%" stripe @row-click="singleElection"
            :data-size="pointsData.length" v-loadmore="handelLoadmore" highlight-current-row height="49vh"
            v-loading="loading">
            <el-table-column align="center" width="40">
              <template slot-scope="scope">
                <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                <el-radio class="radio" v-model="templateSelection" :label="scope.row.fieldsId">&nbsp;&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column align="center" type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column align="center" prop="fields" label="点位名称"> </el-table-column>
            <el-table-column align="center" prop="content" label="点位描述" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="authorization" label="权限" width="80">
              <template slot-scope="{row}">
                <span>{{row.authorization===0?'读':row.authorization===1?'写':'读写'}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="btn-tools">
        <el-button class="btn" type="primary" @click="onSave">保存</el-button>
        <el-button class="btn" type="primary" @click="close">取消</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
  import API from '@/api/parallel';
  import Dialog from '@/components/dialog';
  import SelectTree from './selectTree'
  import {
    getInfo
  } from '@/utils/auth';
  export default {
    components: {
      Dialog,
      SelectTree
    },
    props: ['row'],
    data() {
      return {
        equipId:'',
        loading: false,
        treeProps: {
          children: 'childList',
          label(data) {
            if (!data.equipCode) {
              return data.emsSn
            }
            return data.equipCode + " (" + data.equipName + ")"
          }
        },
        //   当前选择的行的id
        templateSelection: "",
        //   当前选择的行的数据
        checkList: [],
        pointsData: [],
        treeDataConfig: [],
        keywords: '',
        deviceList: [],
        form: {

        },
        useElecList: [{
            label: '大工业（≥315KVA)',
            value: 1
          },
          {
            label: '一般工商业 （普通工业）',
            value: 2
          },
          {
            label: '一般工商业（普通工业除外）',
            value: 3
          },
          {
            label: '一般工商业（地铁）',
            value: 4
          },
          {
            label: '一般工商业（非工业用电）',
            value: 5
          },
          {
            label: '一般工商业（商业）',
            value: 6
          },
          {
            label: '一般工商业（普通工业除外）',
            value: 7
          },
          {
            label: '一般工商业（普通工业专变）',
            value: 8
          },
          {
            label: '一般工商业 （商业、非工业、非专变普通工业）',
            value: 9
          },
          {
            label: '居民用户',
            value: 10
          },
          {
            label: '合表用户',
            value: 11
          }
        ],
        volLevelOptions:[
          {
            label: "0.22kV",
            value: 1
          },
          {
            label: "0.38kV",
            value: 2
          },
          {
            label: "10kV",
            value: 3
          },
          {
            label: "35kV",
            value: 4
          },
          {
            label: "66kV",
            value: 5
          },
          {
            label: "110kV",
            value: 6
          },
          {
            label: "220kV",
            value: 7
          }
        ],
        dlgTitle: '数据点配置',
        tableData: [],
        bindForm: {},
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        currentDataItem: {},
        currentStartIndex: 0,
        currentEndIndex: 20,
        checkedId:''//树的选中id
      };
    },
    computed: {
      filteredData() {
        return this.pointsData.filter((item, index) => {
          if (index < this.currentStartIndex) {
            return false;
          } else if (index > this.currentEndIndex) {
            return false;
          } else {
            return true;
          }
        });
      }
    },
    methods: {
      handelLoadmore(currentStartIndex, currentEndIndex) {
        this.currentStartIndex = currentStartIndex;
        this.currentEndIndex = currentEndIndex;
      },
      //生效项目并网点绑定设备
      takeEffectProjectGridEquipBind() {
        API.takeEffectProjectGridEquipBind({
          equipId: this.form.devicePoint
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功')
          }
        })
      },
      //点击树节点
      handleNodeClick(row) {
        this.loading = true
        this.templateSelection = ''
        this.searchEquipDataPoints(row.id)
      },
      //查询设备下数据点
      searchEquipDataPoints(id) {
        let params = {
          equipId: id
        }
        if (this.keywords) {
          params.search = this.keywords
        }
        API.searchEquipDataPoints(params).then(res => {
          if (res.data.code == 200) {
            this.pointsData = res.data.data
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      },

      //保存基本信息
      onSaveBindBaseInfo() {
        let params = {}
        params.electricityType = this.form.electricityType
        params.equipId = this.form.devicePoint
        params.gridId = this.form.id
        params.rate = this.form.rate
        API.saveProjectGridEquipBind(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功')
            this.init()
          }
        })
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.deviceCode.indexOf(value) !== -1 || data.deviceName.indexOf(value) !== -1;
      },
      //获取树的列表
      getProjectEquipmentTree() {
        let projectId = this.form.projectId
        API.getProjectEquipmentTree({
          projectId: projectId
        }).then(res => {
          if (res.data.code == 200) {
            this.deviceList = res.data.data
          }
        })
      },
      //
      singleElection(row) {
        this.templateSelection = row.id
        this.checkList = this.tableData.filter((item) => item.id === row.id)
      },
      setDevicePoints(row) {
        this.currentDataItem = row
        this.searchEquipDataGroupTree()
        this.keywords = ''
        this.$refs.dlgAdd.open()

      },
      goBack() {
        this.cancel()
      },
      //关闭当前对话框
      close() {
        this.$refs.dlgAdd.close()
      },
      //跳转到列表
      cancel() {
        this.$emit('closeBind')
      },
      //保存
      onSave() {
        let params = {}
        params.dataPointId = this.templateSelection
        params.dataPointTlId = this.currentDataItem.dataPointTlId
        params.equipId = this.equipId
        API.saveProjectGridEquipDataPointBind(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功')
            this.close()
            this.init()

          }
        })
      },
      //查询
      search() {
        this.treeDataConfig = []
        this.pointsData = []
        this.searchEquipDataGroupTree()
      },
      //查询设备的下数据组-树状
      searchEquipDataGroupTree() {
        let params = {}
        params.equipId = this.equipId
        if (this.keywords) {
          params.search = this.keywords
        }
        if (this.currentDataItem.fieldsId) {
          params.dataPointId = this.currentDataItem.fieldsId
        }
        API.searchEquipDataGroupTree(params).then(res => {
          if (res.data.code == 200) {
            this.treeDataConfig = res.data.data.treeNode
            this.checkedId = res.data.data.checkedId
            let self = this
            setTimeout(function() {
              if(self.checkedId){
                self.$refs.tree.setCurrentKey(self.checkedId)
                self.searchEquipDataPoints(self.checkedId)
                self.templateSelection = self.currentDataItem.fieldsId
              }else{
                self.templateSelection = ''
                self.pointsData = []
              }
            }, 1000)
          }
        })
      },
      //根据并网点编号查询项目并网点的绑定设备
      searchProjectGridEquipBindByGrid() {
        API.searchProjectGridEquipBindByGrid({
          gridId: this.row.id
        }).then(res => {
          if (res.data.code == 200) {
            this.form.devicePoint = res.data.data.equipId
            this.form.rate = res.data.data.rate
            this.equipId = res.data.data.equipId
            this.searchProjectGridEquipDataPoints()
          }
        })
      },

      //查询并网点绑定设备的数据点映射
      searchProjectGridEquipDataPoints() {
        if (this.form.devicePoint) {
          API.searchProjectGridEquipDataPoints({
            equipId: this.form.devicePoint
          }).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data
            }
          })
        }
      },
      //初始数据
      init() {
        this.form = this.row
        this.searchProjectGridEquipBindByGrid()
        this.getProjectEquipmentTree()
      },

    },
    created() {
      this.init();
    }
  };
</script>

<style lang="scss">
  @import './static/css/boss.scss';

  .parallel-bind {
    .el-form {
      .el-form-item {
        .el-select {
          width: 280px;
        }

        .el-input {
          width: 280px;
        }
      }
    }

    .filter-tree {
      height: 47vh;
      overflow: auto;
    }

    .mt20 {
      margin-top: 20px;
    }

    .tools {
      text-align: center;
      margin-top: 30px;
    }

    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .parallel-dlg {
      .el-select {
        width: 100% !important;
      }

      .search-div {
        margin: 10px 0px;
      }

      .config-div {
        display: flex;

        .tree-wrap {
          width: 180px;
          height: 50vh;
          border: 1px solid #dcdfe6;
          border-radius: 5px;

          .el-tree {
            margin-top: 10px;
          }
        }

        .points-wrap {
          width: calc(100% - 200px);
          margin-left: 20px;
          border: 1px solid #dcdfe6;
        }
      }

      .el-dialog__wrapper {
        .el-dialog {
          width: 40% !important;

          .el-dialog__footer {
            padding: 0px !important;
          }
        }
      }
    }
  }

  .btn-tools {
    text-align: center;
    margin-top: 35px;

    .btn {
      width: 100px;
    }
  }

  .device-points {
    color: #0261e4;

    &:hover {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/parallelBranch/bind.vue